// businessSettingsApi.js
const apiUrl = process.env.REACT_APP_PUBLIC_API_URL;

export async function getBusinessSettings() {
  const res = await fetch(`${apiUrl}/api/business-setup`);
  return res.json();
}
